import { PlatformTypes, PlatformTypesMap, OrderCateGory, OrderTypeIdentifier } from 'sharedweb/providers/utProto/enums_pb';
import {
    IOrderValidity, OrderTypeInterface, OrderModeInterface, ProductTypeInterface,
    OrderNotificationParams
} from './app.interfaces';
import { OrderStatusInterface } from 'sharedweb/app.interface';
import { AccessType } from 'sharedweb/app.structs';
import { ProductType as ProtoProductType } from 'sharedweb/providers/utProto/enums_pb';
import { OrderMode as ProtoOrderMode } from 'sharedweb/providers/utProto/enums_pb';
import { OrderType as ProtoOrderType } from 'sharedweb/providers/utProto/enums_pb';
import { OrderValidity as ProtoOrderValidity } from 'sharedweb/providers/utProto/enums_pb';
import { PayoutType as ProtoPayoutType } from 'sharedweb/providers/utProto/enums_pb';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { WEB_SM_ExecutionMethod, WEB_SM_OrderStatus, WEB_SmartOrderType, WEB_SM_FeEventType } from 'sharedweb/providers/utProto/webSmartOrder_pb';

export enum ResetPasswordStatus {
    normal = 'A',
    firstTimeLogin = 'N'
}

export enum PlatformType {
    WEB = 'web',
    MOBILE = 'mobile',
    UALGO_MOBILE = 'ualgo_mobile'
}

export enum BuySell {
    buy = 0,
    sell = 1
}

export enum TRADING_TABS {
    OVERVIEW = 0,
    CHARTS = 1,
    OPTION_CHAIN = 2,
    BOOKS = 3,
    SYMBOL_ANALYTICS = 4
}

export enum TRADING_TABSNAME {
    OVERVIEW = 'OVERVIEW',
    CHARTS = 'CHARTS',
    OPTION_CHAIN = 'OPTION_CHAIN',
    BOOKS = 'BOOKS'
}

// export enum OrderStatus {
//     'NEW' = 0,
//     'Pending New' = 1,
//     'Partially Filled' = 2,
//     'Filled' = 3,
//     'Cancelled' = 7,
//     'RMS Reject' = 8,
//     'Replaced' = 9,
//     'Frozen' = 11,
//     'Parked' = 14,
//     'Order In Processing' = 17,
//     'New Rejected' = 18,
//     'Rejected' = 21,
//     'Replace Rejected' = 27
// }

// export enum ProductType {
//     delivery = 'Delivery',
//     intraDay = 'Intraday'
// }

export enum InstrumentType {
    'Common Stock' = 0,
    'Future' = 1,
    'Option' = 2
}

export let ProductType: ProductTypeInterface;
(function (reverseProduct) {
    reverseProduct[reverseProduct['delivery'] = 'Delivery'] = 'delivery';
    reverseProduct[reverseProduct['intraday'] = 'Intraday'] = 'intraday';
    reverseProduct[reverseProduct['carryforward'] = 'CarryForward'] = 'carryforward';
})(ProductType || (ProductType = <ProductTypeInterface>{}));

export let OrderMode: OrderModeInterface;
(function (reverseInst) {
    reverseInst[reverseInst['buy'] = 'Buy'] = 'buy';
    reverseInst[reverseInst['sell'] = 'Sell'] = 'sell';
})(OrderMode || (OrderMode = <OrderModeInterface>{}));

export let OrderStatusAcronym: OrderStatusInterface;
(function (reverseInst) {
    reverseInst[reverseInst['confirmed'] = 'Confirmed'] = 'confirmed';
    reverseInst[reverseInst['partially_filled'] = 'Partially Filled'] = 'partially_filled';
    reverseInst[reverseInst['replaced'] = 'Replaced'] = 'replaced';
    reverseInst[reverseInst['rejected'] = 'Rejected'] = 'rejected';
    reverseInst[reverseInst['new_rejected'] = 'New Rejected'] = 'new_rejected';
    reverseInst[reverseInst['rms_reject'] = 'RMS Rejected'] = 'rms_reject';
    reverseInst[reverseInst['RiskStatus_EXCHANGE_DISCONNECTED'] = 'EXCHANGE DISCONNECTED'] = 'RiskStatus_EXCHANGE_DISCONNECTED';
    reverseInst[reverseInst['replace_rejected'] = 'Replace Rejected'] = 'replace_rejected';
    reverseInst[reverseInst['cancel_rejected'] = 'Cancel Rejected'] = 'cancel_rejected';
    reverseInst[reverseInst['cancelled'] = 'Cancelled'] = 'cancelled';
    reverseInst[reverseInst['filled'] = 'Filled'] = 'filled';
    reverseInst[reverseInst['frozen'] = 'Frozen'] = 'frozen';
    reverseInst[reverseInst['pending_new'] = 'Pending New'] = 'pending_new';
    reverseInst[reverseInst['pending_replace'] = 'Pending Replace'] = 'pending_replace';
    reverseInst[reverseInst['pending_cancel'] = 'Pending Cancel'] = 'pending_cancel';
})(OrderStatusAcronym || (OrderStatusAcronym = <OrderStatusInterface>{}));

export enum optionType {
    CALL = 'CE',
    PUT = 'PE'
}

export enum UserTypes {
    client = 'client',
    dealer = 'dealer'
}

export let OrderValidity: IOrderValidity;
(function (reverseOrder) {
    reverseOrder[reverseOrder['day'] = 'DAY'] = 'day';
    reverseOrder[reverseOrder['gtc'] = 'GTC'] = 'gtc';
    reverseOrder[reverseOrder['ioc'] = 'IOC'] = 'ioc';
    reverseOrder[reverseOrder['ato'] = 'ATO'] = 'ato';
    reverseOrder[reverseOrder['gtd'] = 'GTD'] = 'gtd';
    reverseOrder[reverseOrder['atc'] = 'ATC'] = 'atc';
    reverseOrder[reverseOrder['fok'] = 'FOK'] = 'fok';
})(OrderValidity || (OrderValidity = <IOrderValidity>{}));

export let OrderType: OrderTypeInterface;
(function (reverseOrder) {
    reverseOrder[reverseOrder['limit'] = 'Limit'] = 'limit';
    reverseOrder[reverseOrder['market'] = 'Market'] = 'market';
    reverseOrder[reverseOrder['stop_loss_market'] = 'SL-M'] = 'stop_loss_market';
    reverseOrder[reverseOrder['stop_loss_limit'] = 'SL'] = 'stop_loss_limit';
    reverseOrder[reverseOrder['market_to_limit'] = 'MARKET_WITH_LEFT_OVER_AS_LIMIT'] = 'market_to_limit';
})(OrderType || (OrderType = <OrderTypeInterface>{}));

export const PriceAllowedOrderTypes = [
    OrderType['Limit'],
    OrderType['Stop Loss Limit']
];

export interface FormValidatorErrors {
    quantity: string;
    price: string;
    lots: string;
    amount: string;
    triggerPrice: string;
    disclosedQty: string;
    stopPrice: string,
    targetPrice?: string;
    targetQty?: string;
    targetTriggerPrice?: string;
    stopLossQty?: string;
    stopLossPrice?: string;
    stopLossTriggerPrice?: string;
    trailingPrice?: string;
}

export interface FormValidatorFlags{
    quantity: boolean;
    price: boolean;
    lots: boolean;
    amount: boolean;
    triggerPrice: boolean;
    disclosedQty: boolean;
    stopPrice: boolean;
    targetPrice?: boolean;
    targetQty?: boolean;
    targetTriggerPrice?: boolean;
    stopLossQty?: boolean;
    stopLossPrice?: boolean;
    stopLossTriggerPrice?: boolean;
    trailingPrice?: boolean;
}

export enum DepthClickType {
    BID_VOL = 'BID_VOL',
    BID_PRICE = 'BID_PRICE',
    ASK_PRICE = 'ASK_PRICE',
    ASK_VOL = 'ASK_VOL'
}

export enum ProductCOnversionStatus {
    'Successful' = 1,
    'Rejected' = 2
}

export enum ChartIQSpan {
    '1d' = '1d',
    '5d' = '5d',
    '1m' = '1m',
    '3m' = '3m',
    '1y' = '1y',
    '5y' = '5y',
    'all' = 'all',
    'All' = 'All'
}

export enum ChartIQDisplaySpan {
    all = 'all',
    day = 'day',
    today = 'today',
    month = 'month',
    year = 'year'
}

export enum ChartIqDisplayIntervals {
    minute = '1 Min',
    halfHour = '30 Min',
    hour = '1 Hour',
    day = '1 Day',
    week = '1 Wk',
    month = '1 Mon'
}

export enum ChartIQIntervals {
    minute = 1,
    halfHour = 30,
    day = 'day',
    week = 'week',
    month = 'month'
}

export enum ChartIQChartType {
    bar = 'bar',
    candle = 'candle',
    colored_bar = 'colored_bar',
    hollow_candle = 'hollow_candle',
    line = 'line',
    mountain = 'mountain',
    volume_candle = 'volume_candle',
    heikinashi = 'heikinashi',
    kagi = 'kagi',
    linebreak = 'linebreak',
    renko = 'renko',
    rangebars = 'rangebars',
    pandf = 'pandf',
    priceLines = 'priceLines',
    box = 'box',
    reversal = 'reversal'
}

export enum ChartIQDisplayChartType {
    bar = 'Bar',
    candle = 'Candle',
    colored_bar = 'Colored Bar',
    hollow_candle = 'Hollow Candle',
    line = 'Line',
    mountain = 'Mountain',
    volume_candle = 'Volume Candle',
    heikinashi = 'Heikin-Ashi',
    kagi = 'Kagi',
    linebreak = 'Line Break',
    renko = 'Renko',
    rangebars = 'Range Bars',
    pandf = 'Point & Figure',
    priceLines = 'price line'
}

export enum UserBooks {
    marketWatch = 'marketWatch',
    orderBook = 'orderBook',
    tradeBook = 'tradeBook',
    positions = 'positions',
    marginSummaryColumns = 'marginSummaryColumns',
    holdings = 'holdings',
    productConversionSummary = 'productConversionSummary',
    batchOrdersTable = 'batchOrdersTable',
    fundsBook = 'fundsBook',
    ipoList = 'ipoList',
    ipoOrderBook = 'ipoOrderBook'
}

export enum ChartTypes {
    candle = 'Candle Stick',
    line = 'Line',
    OHLC = 'OHLC',
    area = 'Area Chart'
}

export enum ChartUpdateType {
    new = 'new',
    update = 'update'
}

// Lookup tree Enums

export enum InstrumentLookUpTreeLevel {
    root = 0,
    exchanges = 1,
    market = 2,
    instrument = 3,
    symbol = 4,
    series = 5
}


export const MarketMoversOrderTypes = {
    instrument: 'Instrument',
    index: 'Index'
}

export enum MarketMovers {
    topGainers = 'top-gainers',
    topLosers = 'top-losers',
    mostActive = 'most-active',
    marketMovement = 'mkt-movement'
}

// Personalize view struct

export enum PersonalizeView {
    default = 'default-view-layout',
    pro = 'pro-view-layout'
}

export enum OrderFieldPriority {
    'market' = 0,
    'instrument' = 1,
    'orderType' = 2,
    // 'expirydate' = 4,
    // 'optionType' = 4,
    // 'strikePrice' = 5,
    // 'lots' = 3,
    // 'price' = 4,
    // 'triggerPrice' = 5,
    // 'discloseQty' = 6,
    // 'quantity' = 7,
    'validity' = 3,
    // 'product' = 9,
}

export enum MarketKeywords {
    'BSECM' = 'BSECM',
    'BSEFO' = 'BSEFO',
    'NSECM' = 'NSECM',
    'NSEFO' = 'NSEFO',
    'ESMNSE' = 'ESMNSE',
    'ESM' = 'ESMNSE',
    'NSECDS' = 'NSECDS',
    'BSECDS' = 'BSECDS',
    'MSECM' = 'MSECM',
    'MSECD' = 'MSECD',
    'MSEFO' = 'MSEFO',
    'PLUS' = 'PLUS',
    'MCX' = 'MCX',
}

export enum OrderFormTabIndex {
    buy = 0,
    sell = 1
}

export enum OrderTypeTabIndex {
    REGULAR = 0,
    BO = 1,
    CO = 2
}

export enum WidgetViewMode {
    DEFAULT = 'default',
    FULLSCREEN = 'fullscreen',
    MINIMISED = 'minimised',
    MAXIMISED = 'maximised'
}


export enum AddRemoveSymbolCommand {
    add = 'add',
    remove = 'delete'
}

export enum SpotDerivativeMap {
    NSECM = 'NSEFO',
    BSECM = 'BSEFO',
    MSECM = 'MSECM',
    ESMNSE = 'ESMNSE'
}

export enum SymbolInstrumentType {
    common_stock = 'C',
    future = 'F',
    option = 'O'
}

export enum ReverseInstrumentType {
    'C' = 'common_stock',
    'F' = 'future',
    'O' = 'option'
}

export enum SymbolSearchKeywords {
    'OPT' = SymbolInstrumentType.option,
    'FUT' = SymbolInstrumentType.future,
    'FUTURE' = SymbolInstrumentType.future,
    'OPTION' = SymbolInstrumentType.option
}

export enum SearchResultFieldParams {
    expiry = 'expiry',
    strikePrice = 'strike_price'
}

export enum OtpMessages {
    success = 'Success',
    failure = 'Failure',
    limit = 'Limit'
}

export enum AdminCommands {
    logout = 'logout',
    delete = 'delete',
    pass_modify = 'pass_modify',
}

export enum SubscriptionTables {
    marketWatch = 'marketWatch',
    positions = 'positions',
    indices = 'indices',
    depth = 'depth',
    spreadForm = 'spreadForm',
    depthScalper = 'depthScalper',
    holding = 'holding',
    chart = 'chart',
    orderWidget = 'OrderWidget',
    orderForm = 'orderForm',
    batchOrder = 'batchOrder'
}

export enum MappingType {
    exchange = 'exchange',
    product = 'product',
    client = 'client'
}

export enum BatchFilters {
    All = 'ALL',
    Pending = 'Pending',
    Placed = 'Placed',
    Invalid = 'Invalid'
}

export enum FluidWidgets {
    marketPicture = 'marketPicture',
    chart = 'chart',
    optionChain = 'optionChain',
    userBooks = 'userBooks'
}

export enum SidebarRoutes {
    social = 'social',
    smartMW = 'smartMW',
    // books = 'books',
    orders = 'orders',
    positions = 'positions',
    analytics = 'analytics',
    batch = 'batch',
    reports = 'reports',
    funds = 'funds',
    logout = 'logout',
    home = 'home',
    help = 'help',
    contact = 'contact',
    escalation = 'escalation',
    memberDetails = 'memberDetails',
    expertView = 'expertView',
    research = 'research',
}

export enum ShowHideColumnsKeys {
    batchOrdersTable = 'batchOrdersTable'
}

export enum MarketStatus {
    open = 'market-open',
    closed = 'market-closed',
}

export enum MarketStatusToColorMap {
    'Closed' = 'market-closed',
    'Preopen Closed' = 'market-closed',
    'Post Closed' = 'market-closed',
    'Halted' = 'market-closed',
    'Open' = 'market-open',
    'Preopen' = 'market-open',
    'Post Open' = 'market-open'
}

export enum HoldingType {
    'normal' = 0,
    't+1' = 1,
    'None' = 2
}

export enum DefaultmarketWatch {
    default = 'default'
}

export const CurrentSession = {
    0: 'Pre Open',
    1: 'Open',
    2: 'Closed',
    3: 'Preopen Closed',
    4: 'Post Closed',
    5: 'Halted',
    6: 'Post Open',
    7: 'Start Day Login',
    8: 'End Of Day',
    9: 'Member Query Session',
    10: 'Matching Session End',
    11: 'Preopen Matching Session End',
    12: 'Max'
};

export const PlatformTypeMap = {
    [PlatformTypes.PLATFORMTYPES_EXE_CONSOLE]: AccessType.desktop,     
    [PlatformTypes.PLATFORMTYPES_WEB_CONSOLE]: AccessType.web,       
    [PlatformTypes.PLATFORMTYPES_MOBILE_CONSOLE]: AccessType.mobile,      
    [PlatformTypes.PLATFORMTYPES_DMA_CONSOLE]: AccessType.dma,          
    [PlatformTypes.PLATFORMTYPES_UALGOS_MOBILE]: AccessType.uAlgoMobile,  
};

export const MarketType = {
    0: 'Normal',
    1: 'Odd Lot',
    2: 'Spot',
    3: 'Auction',
    4: 'Call Auction 1',
    5: 'Call Auction 2',
    6: 'Normal Call Auction',
    7: 'SPOS',
    8: 'PCAS1',
    9: 'PCAS2',
    10: 'Max'
};

export const TradeToTradeSeries = {
    NSECM : ['BE'],
    BSECM : ['T','XT']
}

export enum DealerClientMappingType {
    unmapped = 0,
    mapped = 1
}

export enum Themes {
    Dark = 'Elegant Black',
    White = 'Minimal White'
}

export enum OrderFormTypeIndex {
    Regular = 0,
    CO = 1,
    BO = 2,
    AMO = 3
}

export enum OrderFormTypeIndexes {
    Regular = 0,
    BOCO = 1,
    AMO = 2,
    GTT = 3
}

export enum BooksIndex {
    orderbook = 0,
    tradebook = 1
}

export enum StaticLinks {
    help = 'Help',
    contact = 'Contact',
    about_utrade = 'About uTrade',
    user_manual = 'User Manual',
    back_office = 'BackOffice'
}

export enum IpoSectionSate{
    open, //open 0
    closed //closed 1
}

export enum ConfigurationKeys {
    RetailUrls = 'RetailUrls',
    RestUrls = 'RestUrls',
    ChartMarketHours = 'ChartMarketHours',
    EKycUrl = 'EKycUrl',
    SupportPhone = 'SupportPhone',
    SupportEmail = 'SupportEmail',
    RecaptchaRequired = 'RecaptchaRequired',
    AppVersion = 'AppVersion',
    Option_Chain_Strikes = 'Option_Chain_Strikes',
    optionChainDisabledMarkets = 'optionChainDisabledMarkets',
    memberDetails = 'memberDetails',
    OrderToastConfig = 'OrderToastConfig',
    SipConfig= 'SipConfig'
}

export enum FOMarketMap {
    NSECM = 'NSEFO',
    BSECM = 'BSEFO',
    MSECM = 'MSECM'
}

export enum UccOtpTypes {
    generate = 'generate',
    validate = 'validate'
}

export enum EdisChecked {
    authChecked = 'auth_checked',
    unauthChecked = 'unauth_checked'
}

export enum LoggerPrefixes {
    socketLogger = 'SOCKETLOGGER_',
    mainLogger = 'MAINLOGGER_'
}

export enum BiometricAction {
    enable = 'enable',
    disable = 'disable',
    verify = 'verify',
    logout = 'logout',
    logoutSuccess = 'LogoutSuccess',
    logoutFailed = 'LogoutFailed',
    biometricSuccess = 'biometricSuccess',
    biometricFailure = 'biometricFailure',
    redirect = 'redirect',
    serverFailure = 'serverFailure',
    networkFailure = 'networkFailure'
}

export enum WebViewEvent {
    biometricHandler = 'biometricHandler',
}

export enum NudgeMessagesEnum {
    checkSymbolMessage = 'checkSymbolMessage',
    fundsMessage = 'fundsMessage',
    holdingQtyMessage = 'holdingQtyMessage',
    ltpMessage = 'ltpMessage',
    tradeToTradeMessage = 'tradeToTradeMessage',
    regulatoryIndicator = 'regulatoryIndicator'
}

export enum VendorType {
    shareIndia = 'SHAREINDIA',
    sisl = 'SISL'
}

export enum OrderStatusGroup {
    Scheduled = 'Scheduled',
    Placed = 'Placed',
}

export enum TriggerType {
    SINGLE = 'Single',
    OCO = 'OCO'
}

export const GTTTriggerType = {
    'Single': OrderCateGory.ORDERCATEGORY_SINGLE,
    'OCO': OrderCateGory.ORDERCATEGORY_OCO
}

export const GTTTriggerTypeDisplay = {
    [OrderCateGory.ORDERCATEGORY_SINGLE]: 'Single',
    [OrderCateGory.ORDERCATEGORY_OCO]: 'OCO'
}

export const GTTProductTypeDisplay = {
    [ProtoProductType.PRODUCTTYPE_DELIVERY]: 'Delivery',
    [ProtoProductType.PRODUCTTYPE_MTF]: 'MTF',
    [ProtoProductType.PRODUCTTYPE_CARRYFORWARD]: 'CarryForward'
}

export const GTTProductType = {
    'Delivery': ProtoProductType.PRODUCTTYPE_DELIVERY,
    'MTF': ProtoProductType.PRODUCTTYPE_MTF,
    'CarryForward': ProtoProductType.PRODUCTTYPE_CARRYFORWARD
}

export const GTTOrderIdentifier = {
    [OrderTypeIdentifier.ORDERTYPEIDENTIFIER_GTT]: 'GTT',
    [OrderTypeIdentifier.ORDERTYPEIDENTIFIER_SIP]: 'SIP',
    [OrderTypeIdentifier.ORDERTYPEIDENTIFIER_SUPERORDER]: 'SUPER',
    [OrderTypeIdentifier.ORDERTYPEIDENTIFIER_GENERAL_MESSAGE]: 'GENERAL',
    [OrderTypeIdentifier.ORDERTYPEIDENTIFIER_SMARTORDER]: 'SMART'
}

export const SmartBookProductTypeDisplay = {
    [ProtoProductType.PRODUCTTYPE_DELIVERY]: 'Delivery',
    [ProtoProductType.PRODUCTTYPE_MTF]: 'MTF',
    [ProtoProductType.PRODUCTTYPE_CARRYFORWARD]: 'CarryForward',
    [ProtoProductType.PRODUCTTYPE_INTRADAY]: 'Intraday',
    [ProtoProductType.PRODUCTTYPE_BRACKET]: 'Bracket',
    [ProtoProductType.PRODUCTTYPE_COVER]: 'Cover',
    [ProtoProductType.PRODUCTTYPE_ALL]: 'All'
}

export const SuperBookOrderModeDisplay = {
    [ProtoOrderMode.ORDERMODE_BUY]: 'Buy',
    [ProtoOrderMode.ORDERMODE_SELL]: 'Sell'
}

export const SuperBookProductType = {
    'Delivery': ProtoProductType.PRODUCTTYPE_DELIVERY,
    'MTF': ProtoProductType.PRODUCTTYPE_MTF,
    'CarryForward': ProtoProductType.PRODUCTTYPE_CARRYFORWARD,
    'Intraday': ProtoProductType.PRODUCTTYPE_INTRADAY,
    'Bracket': ProtoProductType.PRODUCTTYPE_BRACKET,
    'Cover': ProtoProductType.PRODUCTTYPE_COVER,
    'All': ProtoProductType.PRODUCTTYPE_ALL
}

export const SuperBookOrderTypeDisplay = {
    [ProtoOrderType.ORDERTYPE_LIMIT]: 'Limit',
    [ProtoOrderType.ORDERTYPE_MARKET]: 'Market',
    [ProtoOrderType.ORDERTYPE_STOP_LIMIT]: 'Stop Limit',
    [ProtoOrderType.ORDERTYPE_STOP]: 'Stop',
    [ProtoOrderType.ORDERTYPE_BESTPRICE]: 'Best Price',
}

export const SuperBookOrderStatusDisplay = {
    [WEB_SM_OrderStatus.ORDER_STATUS_PENDING]: 'Pending',
    [WEB_SM_OrderStatus.ORDER_STATUS_ACTIVE]: 'Active',
    [WEB_SM_OrderStatus.ORDER_STATUS_COMPLETED]: 'Completed',
    [WEB_SM_OrderStatus.ORDER_STATUS_CANCELLED]: 'Cancelled',
    [WEB_SM_OrderStatus.ORDER_STATUS_FAILED]: 'Failed',
    [WEB_SM_OrderStatus.ORDER_STATUS_PAUSED]: 'Paused',
}

export const SuperBookOrderEventTypeDisplay = {
    [WEB_SM_FeEventType.FE_EVENT_TYPE_UNSPECIFED]: 'Unspecified',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_CREATED]: 'Created',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_MODIFIED]: 'Modified',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_ACTIVE]: 'Active',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_COMPLETED]: 'Completed',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_CANCELLED]: 'Cancelled',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_FAILED]: 'Failed',
    [WEB_SM_FeEventType.FE_EVENT_TYPE_PAUSED]: 'Paused',
}

export const SmartBookOrderStatusDisplay = {
    [WEB_SM_OrderStatus.ORDER_STATUS_PENDING]: 'Open',
    [WEB_SM_OrderStatus.ORDER_STATUS_ACTIVE]: 'Active',
    [WEB_SM_OrderStatus.ORDER_STATUS_COMPLETED]: 'Completed',
    [WEB_SM_OrderStatus.ORDER_STATUS_CANCELLED]: 'Cancelled',
    [WEB_SM_OrderStatus.ORDER_STATUS_FAILED]: 'Failed',
    [WEB_SM_OrderStatus.ORDER_STATUS_PAUSED]: 'Paused',
}

export const SmartOrderTypeDisplay = {
    [WEB_SmartOrderType.SMART_ORDER_TYPE_TWAP]: 'TWAP',
    [WEB_SmartOrderType.SMART_ORDER_TYPE_POV]: 'POV',
    [WEB_SmartOrderType.SMART_ORDER_TYPE_ICEBERG]: 'Iceberg',
    [WEB_SmartOrderType.SMART_ORDER_TYPE_SUPER_BOCO]: 'Super BOCO',
}

export const SmartBookOrderValidityDisplay = {
    [ProtoOrderValidity.ORDERVALIDITY_DAY]: 'Day',
    [ProtoOrderValidity.ORDERVALIDITY_IOC]: 'IOC',
    [ProtoOrderValidity.ORDERVALIDITY_FOK]: 'FOK',
    [ProtoOrderValidity.ORDERVALIDITY_GFS]: 'GFS',
    [ProtoOrderValidity.ORDERVALIDITY_GFD]: 'GFD',
    [ProtoOrderValidity.ORDERVALIDITY_GTD]: 'GTD',
    [ProtoOrderValidity.ORDERVALIDITY_GTC]: 'GTC',
}
export const PayoutTypeDisplayMap = {
    [ProtoPayoutType.PAYOUTTYPE_REGULAR]: 'Regular',
    [ProtoPayoutType.PAYOUTTYPE_INSTANT]: 'Instant'
}

export const IdentifierType = {
    gtt: 'GTT',
    sip: 'SIP',
    super: 'SUPER',
    general: 'GENERAL',
    smart: 'SMART'
}

export const GTTOrderModeDisplay = {
    [ProtoOrderMode.ORDERMODE_BUY]: 'Buy',
    [ProtoOrderMode.ORDERMODE_SELL]: 'Sell'
}

export const GTTOrderTypeDisplay = {
    [ProtoOrderType.ORDERTYPE_LIMIT]: 'Limit'
}

export enum GTTStatus {
    Open = 'OPEN',
    Pending = 'PENDING',
    Triggered = 'TRIGGERED',
    Cancelled = 'CANCELLED',
    Expired = 'EXPIRED',
    Rejected = 'REJECTED'
}

export enum GttTransactionType {
    Create = 1,
    Modify = 2,
    Cancel = 3
}

export const GTT_DATE_FORMATS = {
    parse: {
        dateInput: 'DD-MMM-YY',
    },
    display: {
        dateInput: 'DD-MMM-YY',
        monthYearLabel: 'MMM YY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YY',
    }
};

export const GTT_DATE_PROVIDERS = [
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {
        provide: MAT_DATE_FORMATS,
        useValue: GTT_DATE_FORMATS
    }
];

export enum FormState {
    LOGIN_FORM = 'LOGIN_FORM',
    UCC_PHONE = 'UCC_PHONE',
    FORGOT_FORM = 'FORGOT_FORM',
    PIN_AUTH = 'PIN_AUTH',
    UCC_OTP = 'UCC_OTP',
    RESET_PASSWORD = 'RESET_PASSWORD',
    FIRST_TIME_CHANGE_PASSWORD = 'FIRST_TIME_CHANGE_PASSWORD',
    SYSTEM_UPDATE = 'SYSTEM_UPDATE'
}

// This is used for selecting the tab from the url params
export enum TradingTabs {
    HOME = 0,
    BOOKS = 1,
    POSITIONS = 2,
    HOLDINGS = 3,
    FUNDS = 4,
    IPO = 5
}

export enum BooksTabs {
    ORDER_BOOK = 0,
    TRADE_BOOK = 1,
    STOCK_SIP = 2,
    GTT = 3,
}

export enum SmartExecutionType {
    ICEBERG = 'ICEBERG',
    POV = 'POV',
    TWAP = 'TWAP'
}

export const SmartExecutionTypeMap = {
    [WEB_SmartOrderType.SMART_ORDER_TYPE_TWAP]: SmartExecutionType.TWAP,
    [WEB_SmartOrderType.SMART_ORDER_TYPE_POV]: SmartExecutionType.POV,
    [WEB_SmartOrderType.SMART_ORDER_TYPE_ICEBERG]: SmartExecutionType.ICEBERG
}

export const SmartExecutionTypeDisplay = {
    [SmartExecutionType.ICEBERG]: 'Iceberg',
    [SmartExecutionType.POV]: 'POV',
    [SmartExecutionType.TWAP]: 'TWAP'
}

export enum SmartExecutionMethods {
    BEST_PRICE = 'Best Price',
    QUICK_FILL = 'Quick Fill',
    LOWEST_PRICE = 'Lowest Price',
    LIMIT_PRICE = 'Limit Price'
}

export const SmartExecutionMethodsMap = {
    [WEB_SM_ExecutionMethod.EXECUTION_METHOD_BEST_PRICE]: SmartExecutionMethods.BEST_PRICE,
    [WEB_SM_ExecutionMethod.EXECUTION_METHOD_QUICK_FILL]: SmartExecutionMethods.QUICK_FILL,
    [WEB_SM_ExecutionMethod.EXECUTION_METHOD_LOWEST]: SmartExecutionMethods.LOWEST_PRICE,
    [WEB_SM_ExecutionMethod.EXECUTION_METHOD_LIMIT_PRICE]: SmartExecutionMethods.LIMIT_PRICE
}

export const SmartExecutionMethodsDisplay = {
    [SmartExecutionMethods.BEST_PRICE]: 'Best Price',
    [SmartExecutionMethods.QUICK_FILL]: 'Quick Fill',
    [SmartExecutionMethods.LOWEST_PRICE]: 'Lowest Price',
    [SmartExecutionMethods.LIMIT_PRICE]: 'Limit Price'
}
export interface SmartFormValidatorErrors {
    limitPrice: string;
    quantity: string;
    marketVolumePercentage: string;
    triggerPrice: string;
    startTime: string;
    endTime: string;    
    interval: string;
}

export interface SmartFormValidatorFlags {
    limitPrice: boolean;
    quantity: boolean;
    marketVolumePercentage: boolean;
    triggerPrice: boolean;
    startTime: boolean;
    endTime: boolean;
    interval: boolean;
}

export interface SmartProductType {
    label: string;
    value: number;
}

export enum WithdrawalMode {
    regular = 'regular',
    instant = 'instant'
  }